module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7362/img/screenshot-og.png"